// import axios from 'axios';
import $ from 'jquery';
// import { parseQueryParams } from './shared/utils';

// in-page pricing period toggle logic
(function () {
  const toggleButtons = document.querySelectorAll(".toggle-element");
  const priceElements = document.querySelectorAll(".plan-cost-amount");
  const priceUnitElements = document.querySelectorAll(".plan-cost-unit");
  const billingLabels = document.querySelectorAll(".plan-billing-period");

  toggleButtons.forEach(button => {

    button.addEventListener("click", function () {
      const selectedType = button.getAttribute("data-type"); // 'monthly' or 'yearly'

      // Update prices
      priceElements.forEach(el => {
        const monthlyPrice = el.getAttribute("data-monthly-price");
        const annualPrice = el.getAttribute("data-annual-price");

        el.textContent = selectedType === "monthly"
          ? `$${monthlyPrice}`
          : `$${annualPrice}`;
      });

      // priceUnitElements.forEach(el => {
      //   el.innerHTML = selectedType === "monthly"
      //     ? 'per month'
      //     : 'per month'
      // })

      // Update billing labels
      billingLabels.forEach(label => {
        label.textContent = selectedType === "monthly"
          ? "Billed Monthly"
          : "Billed Yearly";
      });

      // Update active button state (optional)
      toggleButtons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("toggle-element-checked");

      let otherButton = (button.nextElementSibling || button.previousElementSibling)
      if (otherButton) {
        otherButton.classList.remove("toggle-element-checked");
      }
    });
  });

  // in-page customer reviews scroller
  const sliders = document.querySelectorAll(".customer-review-card-list");

  sliders.forEach(slider => {
    const cards = slider.children;
    const cardWidth = cards[0].offsetWidth + parseInt(getComputedStyle(cards[0]).marginRight);
    let scrollPosition = 0;
    let isPaused = false;

    // Clone cards to enable seamless looping
    const cloneCount = Math.ceil(slider.offsetWidth / cardWidth) + 1;
    for (let i = 0; i < cloneCount; i++) {
      slider.appendChild(cards[i % cards.length].cloneNode(true));
    }

    function autoScroll() {
      if (!isPaused) {
        scrollPosition += 0.5;
        if (scrollPosition >= slider.scrollWidth / 2) {
          scrollPosition = 0;
          slider.scrollLeft = 0;
          // console.log('slider.scrollLeft=0')
        } else {
          slider.scrollLeft = scrollPosition;
          // console.log('slider.scrollLeft=', scrollPosition)
        }
      }

      // setTimeout(() => {
      //   autoScroll()
      // }, 0);
      requestAnimationFrame(autoScroll);
    }

    autoScroll();

    // Pause/resume on hover
    slider.addEventListener("mouseover", () => isPaused = true);
    slider.addEventListener("mouseout", () => isPaused = false);
  })

}());